import _round from 'lodash/round';

/**
 * Based on the `earnings` and `percent_share` for this PRO member, calculate the track splits.
 * Assume that collaborators were paid at the same rate and calculate their percent share and
 * earnings. Sum the earnings for this PRO member and collaborators and include as
 * result.total_earnings.
 *
 * For example, if this PRO member was paid $70 and owned a 70% share, the returned value would be:
 *
 *  {
 *      collaborator_earnings: 30,
 *      collaborator_percent_share: 30.0,
 *      earnings: 70,
 *      percent_share: 70.0,
 *      total_earnings: 100,
 *      work_title: 'Our Awesome Jam',
 *  }
 */
export const calculateTrackSplits = ({
    work_title,
    earnings,
    percent_share,
}: CalculateTrackSplitsElement): TrackSplits => {
    if (
        percent_share === null ||
        percent_share === undefined ||
        percent_share === 0 ||
        earnings === null ||
        earnings === undefined
    ) {
        return {
            collaborator_earnings: 0,
            collaborator_percent_share: null,
            earnings: earnings ?? null,
            percent_share: percent_share ?? null,
            total_earnings: earnings ?? null,
            work_title: work_title ?? null,
        };
    }

    const total_earnings =
        percent_share === 0 ? 0 : _round((100 / percent_share) * earnings, 2);
    const collaborator_earnings = total_earnings - earnings;
    const collaborator_percent_share = 100 - percent_share;

    return {
        collaborator_earnings,
        collaborator_percent_share,
        earnings,
        percent_share,
        total_earnings,
        work_title: work_title ?? null,
    };
};
